import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const Profile = () => {
  const { user } = useAuth();
  const { t } = useLanguage();

  return (
    <>
      <SEO
        title="My Profile - Account Settings"
        description="Manage your Meller Racing account settings, view order history, and update personal information."
        keywords="profile, account settings, user dashboard"
        noindex={true}
      />

      <div className="container-custom py-12">
        <h1 className="text-3xl font-display font-bold mb-8">{t('profile.title')}</h1>

        <div className="max-w-2xl">
          <div className="card p-6">
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">{t('profile.username')}</label>
                <p className="text-lg font-semibold">{user?.username}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">{t('profile.email')}</label>
                <p className="text-lg font-semibold">{user?.email}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">{t('profile.fullName')}</label>
                <p className="text-lg font-semibold">{user?.full_name || t('profile.notProvided')}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">{t('profile.accountType')}</label>
                <p className="text-lg font-semibold capitalize">{user?.role}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">{t('profile.memberSince')}</label>
                <p className="text-lg font-semibold">
                  {user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
